import { render } from "./ReflectionPage.vue?vue&type=template&id=0de4bebf&scoped=true"
import script from "./ReflectionPage.vue?vue&type=script&lang=js"
export * from "./ReflectionPage.vue?vue&type=script&lang=js"

import "./ReflectionPage.vue?vue&type=style&index=0&id=0de4bebf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de4bebf"]])

export default __exports__